export const ProjectMemberTypes = [
  {id: 'manager', label: 'Người quản lý'},
  {id: 'member', label: 'Thành viên'},
];

export const ProjectStatuses = [
  {id: 'pending', label: 'Chưa bắt đầu'},
  {id: 'in_progress', label: 'Đang thực hiện'},
  {id: 'completed', label: 'Hoàn thành'},
  {id: 'cancelled', label: 'Đã hủy'},
  {id: 'on_hold', label: 'Tạm dừng'},
  {id: 'under_review', label: 'Đang nghiên cứu'},
];

// Status color mapping for consistent UI representation
export const ProjectStatusColors = {
  completed: '#10B981', // green
  in_progress: '#3B82F6', // blue
  pending: '#8B5CF6', // purple
  cancelled: '#EF4444', // red
  on_hold: '#F59E0B', // yellow
  under_review: '#6B7280', // gray
};

// Map status IDs to their positions in the color array for chart usage
export const getStatusColorMap = () => {
  const statusColorMap: {[key: string]: number} = {};
  const colors = Object.values(ProjectStatusColors);
  
  ProjectStatuses.forEach((status, index) => {
    statusColorMap[status.id] = index % colors.length;
  });
  
  return statusColorMap;
};
